module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Group-e338db2aa3dfa36b582242713f945b86.svg";